var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSudan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9801 144.696C9.70613 178.352 0.578125 216.109 0.578125 256C0.578125 295.891 9.70613 333.648 25.9801 367.304L256.578 389.565L487.176 367.304C503.45 333.648 512.578 295.891 512.578 256C512.578 216.109 503.45 178.352 487.176 144.696L256.578 122.435L25.9801 144.696Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.989 367.304C67.395 452.935 155.084 512 256.578 512C358.072 512 445.761 452.935 487.167 367.304H25.989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.989 144.696H487.167C445.761 59.065 358.072 0 256.578 0C155.084 0 67.395 59.065 25.989 144.696Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5581 74.98C-24.4159 174.954 -24.4159 337.045 75.5581 437.02C116.871 395.707 156.604 355.974 256.578 256L75.5581 74.98Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.578125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSudan);
export default __webpack_public_path__ + "static/media/sudan.5610c07198c35ce27f7af9b28d5655db.svg";
export { ForwardRef as ReactComponent };